import { flatten, map } from 'lodash';

export class CompleteIhms {
  actionItemId?: string;
  documentInfo: DocumentInfo[];

  constructor(data: any) {
    this.actionItemId = data?.actionItemId;
    const flattenedDocs: DocumentInfo[] = flatten(data?.documentInfo || []);
    this.documentInfo = map(
      flattenedDocs,
      (doc: DocumentInfo) => new DocumentInfo(doc)
    );
  }
}

export class DocumentInfo {
  lF_id?: string;
  document_name?: string;
  document_description?: string;
  document_id?: string;

  constructor(data: any) {
    this.lF_id = data?.lfEntryID.toString();
    this.document_name = data?.documentFileName;
    this.document_description = data?.documentDescription;
    this.document_id = data?.lfEntryID?.toString();
  }
}
